<template>
  <div class="thirdaccesstable">
    <el-table :data="tableData" style="width: 100%;padding:10px 10px 0 10px;"  border>
      <el-table-column prop="createMyAt" label="回调时间" width="200"></el-table-column>

      <el-table-column prop="actionName" label="触发动作" width="200"></el-table-column>

      <el-table-column prop="condition" label="筛选条件"></el-table-column>

      <el-table-column  label="回调内容" width="180">
        <template slot-scope="scope">
          <span style="cursor: pointer; color: #5b9bd1;" @click="seeJson(scope)">点击查看（JSON）</span>
        </template>
      </el-table-column>

      <el-table-column prop="requestNumber" label="回调次数" width="100"></el-table-column>

      <el-table-column prop="result" label="反馈状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1" style="cursor: pointer;">
            <el-tag @click="error(scope)" type="success">{{'正常'}}</el-tag>
          </div>

          <div v-if="scope.row.status == 0" style="cursor: pointer;">
            <el-tag @click="error(scope)" type="danger">{{'异常(查看信息)'}}</el-tag>
          </div>

          <div v-if="scope.row.status == -1">
            <el-tag>{{'未触发'}}</el-tag>
          </div>

        </template>
      </el-table-column>

      <el-table-column prop="requestTime" label="响应时间">
        <template slot-scope="scope">
          {{scope.row.requestTime}}毫秒
        </template>
      </el-table-column>


    </el-table>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="26%"
      :before-close="handleClose"
    >
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>{{dialogTitle}}</div>
      </div>
      <div>
        <div style="display:flex;">
          <p style="width:80px;">回调目标：</p>
          <div class="content">
            {{ruleForm.url || '暂无内容'}}
          </div>
        </div>
        <div style="display:flex;margin-top:15px;">
          <p style="width:80px;">{{ruleForm.name}}：</p>
          <div class="result">
            {{ruleForm.text || '暂无内容'}}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  getCallback,
  getCallbackLog
} from "@/api/callback";
export default {
  name: "thirdaccesstable",
  props: {
    tableData:Array,
  },
  data() {
    return {
      picMsg:{},
      dialogTitle:'',
      dialogVisible:false,
      ruleForm:{
        name:'',
        url:'',
        text:''
      }
    };
  },
  methods: {

    async error(scope) {
      // console.log(scope.row);
      this.dialogTitle = '查看反馈信息'
      this.ruleForm.name = '反馈信息'
      let { status, data, message, errors } = await getCallbackLog(scope.row.id);
      if (status) {
        this.ruleForm.text = data.result
      }
      if(scope.row.callbackId && scope.row.callbackId !== 0){
        this.getCallbackAsync(scope.row.callbackId)
      }else{
        this.ruleForm.url = scope.row.targetUrl
        this.dialogVisible = true
      }
      

    },
    seeJson(scope) {
      
      this.dialogTitle = '查看回调内容'
      this.ruleForm.name = '回调内容'
      this.ruleForm.text = scope.row.content
      if(scope.row.callbackId && scope.row.callbackId !== 0){
        this.getCallbackAsync(scope.row.callbackId)
      }else{
        this.ruleForm.url = scope.row.targetUrl
        this.dialogVisible = true
      }
    },

    handleClose(){
      this.dialogVisible = false
    },

    //获取
    async getCallbackAsync(val) {
      let { status, data, message, errors } = await getCallback(val);
      
      if (status) {
        this.ruleForm.url = data.target
        this.dialogVisible = true
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },
  },
  created() {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
.table {
  width: auto;
}

.el-table /deep/ .cell .tit:hover{
  text-decoration: underline !important;
}

.content{
  width: calc(100% - 80px);
  min-height: 30px;
  display: flex;
  background-color: #F5F7FA;
  border: 1px solid  #E4E7ED;
  padding: 5px 10px;
}
.result{
  width: calc(100% - 80px);
  min-height: 160px;
  overflow-y: auto;
  display: flex;
  background-color: #F5F7FA;
  border: 1px solid  #E4E7ED;
  padding: 5px 10px;
}
</style>
